import type { IconData } from '@stacksjs/iconify-core'

export const natureFlower: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 8a5 5 0 0 1 3.297-4.703a5.002 5.002 0 0 1 9.406 0a5.002 5.002 0 0 1 0 9.406a5.002 5.002 0 0 1-9.406 0A5 5 0 0 1 0 8m8 3a3 3 0 1 0 0-6a3 3 0 0 0 0 6\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureFlower
